"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClosedCaptions = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ClosedCaptions = function ClosedCaptions() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C1.79086 4 0 5.79086 0 8V16C0 18.2091 1.79086 20 4 20H20C22.2091 20 24 18.2091 24 16V8C24 5.79086 22.2091 4 20 4H4ZM7.79297 8C9.72656 8 11.1523 9.09375 11.3477 11.0078H9.39453C9.29688 10.207 8.72266 9.69531 7.84375 9.69531C6.67578 9.69531 5.97266 10.582 5.97266 12.1094C5.97266 13.6992 6.69141 14.5234 7.83203 14.5234C8.67969 14.5234 9.25781 14.0664 9.39453 13.2969L11.3477 13.3086C11.2031 14.7266 9.98828 16.2188 7.79297 16.2188C5.62109 16.2188 4 14.7422 4 12.1094C4 9.46484 5.66016 8 7.79297 8ZM16.1611 8C18.0947 8 19.5205 9.09375 19.7158 11.0078H17.7627C17.665 10.207 17.0908 9.69531 16.2119 9.69531C15.0439 9.69531 14.3408 10.582 14.3408 12.1094C14.3408 13.6992 15.0596 14.5234 16.2002 14.5234C17.0479 14.5234 17.626 14.0664 17.7627 13.2969L19.7158 13.3086C19.5713 14.7266 18.3564 16.2188 16.1611 16.2188C13.9893 16.2188 12.3682 14.7422 12.3682 12.1094C12.3682 9.46484 14.0283 8 16.1611 8Z",
    fill: "currentColor"
  }));
};

exports.ClosedCaptions = ClosedCaptions;